import { missingValue } from '../constants';

export const getValue = (input, callback = input => input ) => input ? callback(input) : missingValue;
export const getEditableValue = (field, isEditable, defualt='') => isEditable ? (field !== null ? field : defualt) : getValue(field);